import React, { Component } from "react";
import appConfig from '../../config/config';
import axios from "axios";
import { Field, reduxForm } from "redux-form";
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } from "../common/renderinput";
import {  Button } from 'reactstrap';
import { connect } from "react-redux";
import Banner from "../common/banner";
import {Loading,LoadingDone,Reset,Success,Error} from "../../actions/loading.js"
import PageSpinner from "../PageSpinner";
//Handle initial Data load 

//Handle form submit



class OrderTitleForm extends Component {
    constructor(...args) {
        super(...args);
    }
    //Get the data from API so that we can store in state
    componentDidMount() {
        console.log('loadingtitle')
        this.props.Loading()
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({ OrderProductId: this.props.OrderProductId, Action: "OrderTitle" }),
            {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => {
            //Invoke dispatch to store data in state
            this.props.LoadingDone()
            var OrderTitleData = JSON.parse(response.data.body);
              this.props.dispatch({
                    type: "LOAD", 
                    data: {
                        LegalDesc: OrderTitleData.length > 0 ? OrderTitleData[0].LegalDesc : '',
                        DeedVesting: OrderTitleData.length > 0 ? OrderTitleData[0].DeedVesting: '',
                        ACK: (OrderTitleData.length > 0 && ('ACK' in OrderTitleData[0]))? OrderTitleData[0].ACK: ''

                    }
                });
        },
        (error) => {
            this.props.LoadingDone()
            this.props.Error(error)
        })
    }
    submit = (values) => {
      this.props.Loading()
        axios.post(
            appConfig.apiGateway.updateOrderUrl,
            JSON.stringify({
                ...values, 
                OrderProductId: this.props.OrderProductId,
                Action: "UpdateOrderTitle",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => { 
          this.props.LoadingDone()
          this.props.Success("Title data saved")
        },
        (error) => {
            this.props.LoadingDone()
            this.props.Error(error)
        })
    }
    render() {
      console.log(this.props)
        return (
          <form
            onSubmit={this.props.handleSubmit(this.submit)}
            style={{ marginLeft: "0%", marginRight: "5%" }}
          >
            {this.props.loading.showBanner && (
                      <Banner
                        Close={()=> this.props.Reset()}
                        message={this.props.loading.message}
                        IsSuccess={this.props.loading.isSuccess}
                      />
                    )}
                     {(this.props.loading.loading == true) && (< PageSpinner />)}
            <div className="form-row col-12 pl-0 mt-2">
              <div className="col-10">
                <Field
                  name="DeedVesting"
                  component={renderTextArea}
                  label="Deed"
                  isLabel={true}
                />
              </div>
            </div>
            <div className="form-row col-12 pl-0 mt-2">
              <div className="col-10">
                <Field
                  name="LegalDesc"
                  component={renderTextArea}
                  label="Legal Description"
                  isLabel={true}
                />
              </div>
            </div>
            <div className="form-row col-12 pl-0 mt-2">
            <div className="col-2">
                        <Field
                          name="SendToClient"
                          component={renderCheckbox}
                          label="Send To Client"
                          isLabel="true"
                        />
                      </div>
            <div className="col-2">
                        <Field
                          name="SentDate"
                          component={renderInput}
                          label="Sent Date"
                          isLabel="true"
                        />
                      </div>

              <div className="col-4 offset-4" >
                <Button color="primary" type="submit">
                  Save
                </Button>
              </div>
            </div>
            <div className="form-row col-10 pl-0 mt-2">
            <div className="col-12">
                        <Field
                          name="ACK"
                          component={renderInput}
                          label="ACK/NACK"
                          isLabel="true"
                        />
                      </div>             
            </div>
          </form>
        );
    }
}
const validate = (formValues) => {
    const errors = {};
    if (!formValues.Note) {
        errors.Note = "Please add note ";
    }
    return errors;
}
var orderTitleForm = reduxForm({
    form: 'orderTitleForm',
    validate,
    enableReinitialize: true
})(OrderTitleForm);

orderTitleForm = connect(
    state => ({
        session: state.session,
        initialValues: state.OrderTitle.initdata,
        loading : state.loading
    }),
    {LoadingDone,Loading,Success,Error,Reset}
)(orderTitleForm);

export default orderTitleForm;